import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler, gridSlice } from 'Modules'
import { RequestParams, ResponseCatalog } from 'Models'
import { routerActions } from 'connected-react-router'
import { FrontUrls } from 'Constants/FrontUrls'
import { FormNames } from 'Src/constants/FormNames'
import {
	businessappsApi,
	BusinessappsModel,
	businessappsSelectors,
	businessappsSlice,
	BusinessappssNS,
} from 'Pages/orders'

function* getList(action: BusinessappssNS.GetBusinessappsList) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(businessappsSlice.actions.clearAll())
		}
		const res = yield* call(businessappsApi.getAll, requestParams)
		const businessapp = new ResponseCatalog<BusinessappsModel>(res)
		if (!clear) {
			const oldBusinessapps = yield* select(businessappsSelectors.selectEntries)
			businessapp.entries = oldBusinessapps.concat(res.entries)
		}
		yield* put(businessappsSlice.actions.setBusinessappsList(businessapp))
		yield* put(businessappsSlice.actions.setRequestParams(requestParams))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* getOne(action: BusinessappssNS.GetOne) {
	try {
		yield* put(businessappsSlice.actions.setIsLoading(true))
		const res = yield* call(businessappsApi.getOne, action.payload)
		yield* put(businessappsSlice.actions.setOne(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(businessappsSlice.actions.setIsLoading(false))
	}
}

function* createOne(action: BusinessappssNS.CreateOne) {
	try {
		yield* put(businessappsSlice.actions.setIsLoading(true))
		const res = yield* call(businessappsApi.createOne, action.payload)
		yield* put(businessappsSlice.actions.setOne(res))
		yield* put(routerActions.push(FrontUrls.orders.businessapps))
	} catch (error) {
		yield* call(errorHandler, error, FormNames.BUSINESSAPPS.EDIT)
	} finally {
		yield* put(businessappsSlice.actions.setIsLoading(false))
	}
}

function* updateOne(action: BusinessappssNS.UpdateOne) {
	try {
		yield* put(businessappsSlice.actions.setIsLoading(true))
		const { attachment } = yield* select(businessappsSelectors.selectItem)
		if (attachment && !action.payload.data.attachment_attributes) {
			yield* call(businessappsApi.deleteFile, attachment.id, attachment.name)
		}
		const res = yield* call(businessappsApi.updateOne, action.payload.id, action.payload.data)
		yield* put(businessappsSlice.actions.setOne(res))
		action.payload.callback?.()
	} catch (error) {
		yield* call(errorHandler, error, FormNames.BUSINESSAPPS.EDIT)
	} finally {
		yield* put(businessappsSlice.actions.setIsLoading(false))
	}
}

function* deleteOne(action: BusinessappssNS.DeleteOne) {
	try {
		yield* put(businessappsSlice.actions.setIsLoading(true))
		yield* call(businessappsApi.deleteOne, action.payload)
		yield* put(businessappsSlice.actions.getBusinessappsList)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(businessappsSlice.actions.setIsLoading(false))
	}
}

export function* businessappsSaga() {
	yield* takeLatest(businessappsSlice.actions.getBusinessappsList.type, getList)
	yield* takeLatest(businessappsSlice.actions.getOne.type, getOne)
	yield* takeLatest(businessappsSlice.actions.createOne.type, createOne)
	yield* takeLatest(businessappsSlice.actions.updateOne.type, updateOne)
	yield* takeLatest(businessappsSlice.actions.deleteOne.type, deleteOne)
}
